import setReduxAction from '../../../../redux/actions/set'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import WORKOUT_EXERCISES_PATH from '../../constants/path'

export default function updateCurrentSetIndexWorkoutExerciseAction (value) {
  return setReduxAction({
    type: value != null
      ? WORKOUT_EXERCISES_ACTION.UPDATE_CURRENT_SET_INDEX
      : WORKOUT_EXERCISES_ACTION.RESET_CURRENT_SET_INDEX,
    payload: {
      path: WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX,
      value
    }
  })
}
